<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'modal-header-tablet'
        : 'modal-header-mobile'
      : 'modal-header-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-custom-group-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  class="simple-action-modal_content"
  tabletTouchMove
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'modal-content-tablet'
        : 'modal-content-mobile'
      : 'modal-content-desktop'
  "
>
  <ion-grid>
    <ion-row>
      <ion-col>
        <p class="text-title no-margin margin-bottom-standard title-top-margin">
          {{ 'i18n.menuProfitPro.customGroup.title' | translate }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <p class="text-heading no-margin margin-bottom-standard">
          {{ 'i18n.menuProfitPro.customGroup.for' | translate | sentenceCase }}
          {{ recipeName }}
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-item [class.invalid]="containsEmojis">
          <ion-input
            [(ngModel)]="customGroupName"
            [placeholder]="
              'i18n.menuProfitPro.customGroup.placeholder' | translate
            "
            [maxlength]="maxLength"
            (ngModelChange)="onCustomGroupChange($event)"
            data-cy="custom-group-input"
          ></ion-input>
        </ion-item>
        <p *ngIf="containsEmojis" class="text-small invalid-character-warning">
          {{
            'i18n.menuProfitPro.customGroup.invalidCharacterError' | translate
          }}
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-custom-group-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="submit-modal-btn"
        data-cy="submit-custom-group-modal-button"
        [disabled]="containsEmojis || !customGroupName.trim()"
        [ngClass]="
          containsEmojis || !customGroupName.trim()
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.submit' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
